<template>
  <v-container class="pa-0">
    <v-toolbar dark dense :color="appColor_Medium">
      <v-toolbar-title>
        <span><v-icon class="mr-2">security</v-icon>{{ getExpression('FormTitle', 'ChangePassword') }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pa-0">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show ? 'text' : 'password'"
                  name="input-10-1"
                  :label="getExpression('Label', 'NewPassword')"
                  :hint="getExpression('Validation', 'PasswordMinChars').replace('{0}', '8')"
                  counter
                  @click:append="show = !show"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pt-4 pb-4">
        <v-spacer />
        <v-btn
          text
          @click="close"
          :disabled="isSaving"
          >{{ getExpression('Button', 'Cancel') }}
        </v-btn>        
        <v-btn
          :color="appColor_Light"
          text
          @click="save"
          :loading="isSaving"
          :disabled="!valid || isSaving"
          >{{ getExpression('Button', 'Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'

export default {
  name: 'ProfilePassword',
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      appColor_Light: AppColor.Light,
      appColor_Medium: AppColor.Medium,
      isSaving: false,
      show: false,
      password: '',
    }
  },
  computed: {
    valid () {
      return this.password.length >= 8
    },
    rules () {
      return {
        required: value => !!value || this.getExpression('Validation', 'Required'),
        min: v => v.length >= 8 || this.getExpression('Validation', 'PasswordMinChars').replace('{0}', '8'),
      }
    }
  },
  methods: {
    save () {
      const self = this
      self.isSaving = true
      appService.updateUserPassword(self.userId, { password: self.password }).then(data => {
        this.reset()
        this.password = ''
        if (data.errorSeverity > 0) {
          self.$emit('error', data.errorMessage)
        } else {
          self.$emit('close')
        }
        self.isSaving = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    reset () {
      this.$refs.form.reset()
    },

    close () {
      this.password = ''
      this.reset()
      this.$emit('close')
    }
  }
}
</script>
